"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _image = _interopRequireDefault(require("@atlaskit/icon/core/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MediaServicesScaleSmallIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 8.575v6.85a.57.57 0 0 0 .575.575h6.85a.57.57 0 0 0 .575-.575v-6.85A.57.57 0 0 0 15.425 8h-6.85A.57.57 0 0 0 8 8.575m-2 0A2.57 2.57 0 0 1 8.575 6h6.85A2.57 2.57 0 0 1 18 8.575v6.85A2.57 2.57 0 0 1 15.425 18h-6.85A2.57 2.57 0 0 1 6 15.425z"/><path d="M11.425 14.857h3.146a.29.29 0 0 0 .286-.29v-.935a.42.42 0 0 0-.1-.256l-1.324-1.456c-.062-.069-.145-.065-.201-.01l-1.803 1.804-.47-.469a.14.14 0 0 0-.204 0L9.34 14.66c-.105.105-.066.197.095.197z"/><circle cx="10.286" cy="10.286" r="1.143"/></g></svg>`
}, props, {
  newIcon: _image.default
}));
MediaServicesScaleSmallIcon.displayName = 'MediaServicesScaleSmallIcon';
var _default = exports.default = MediaServicesScaleSmallIcon;